/* eslint-disable indent */
import { cloneDeep, get, head, isEmpty } from 'lodash';
import { Toast } from 'antd-mobile';
import { history } from 'umi';
import {
  qryPlayChancesDXP,
  toPlayDXP,
  qryLuckyDrawDetailWheelDXP,
  qryLuckyDrawDetailKOIDXP,
  qryLuckyDrawDetailReferralDXP,
  qryLuckyDrawDetailSignDXP,
  getAchieveRecordsDXP,
  batchCreateUtmLink,
  reducePointGetChancesDXP,
  getPromotionLuckyDrawRuleDXP,
  qryBalanceOfPointsDXP,
  qryAppCode,
  reducePointGetChancesRetryDXP,
  qryUserInfo,
  qryUserInfoDXP,
  qryNationalPrefix,
  getConfigParam,
  getConfigParamBatch,
  pointTransferDXP,
  pointTransferLimits,
  qryVoucherListDXP,
  qryThemesLatest,
  qryApiSgAuthToken,
  getUtmLink,
  getGAReportConfig,
  qryEshopUser,
  qryConfigItemParamValueByCode,
  getLocalI18n,
  getGameI18n,
  qryDefaultConfig,
} from '@/services';

export default {
  namespace: 'index',
  state: {
    gameCode: '',
    isDXP: true,
    dxpToken: {},
    activityList: [],
    defaultPlayChances: 0,
    winningUserList: [], // 中奖用户
    rewardsList: [],
    activityDetail: {},
    winningReward: {},
    exchangeChanceFlag: '', // 积分兑换抽奖标识
    Luckycode: '2',
    shortLink: '', // 生成的分享短链
    luckyDrawState: '',
    playChances: '',
    isPto: false, // 调用配置项查看是否是PTO dito项目，
    product: null,
    userDimension: null,
    fromGetMore: false,
    projectName: '',
    withoutAuthentification: 'false', // 是否关闭鉴权，false为需要鉴权，true为关闭了鉴权
    isUCAuthentication: false, // 是否走uc鉴权
    pointType: '', // 积分兑换抽奖机会的积分类型
    pageRenderDetail: {},
    referralServerUrl: '',
    isMulPoints: false,
    isWeb: false,
  },
  reducers: {
    save(state, { payload }) {
      return { ...state, ...payload };
    },
  },
  effects: {
    *qryLuckyDrawDetailDXP({ payload }, { put, call, select }) {
      const initAppStr = window.localStorage.getItem('initApp');
      const initApp = JSON.parse(initAppStr) || {};
      const { product, userDimension } = history.location.query;
      // uc鉴权不需要phone
      const isUCAuthentication = yield select(({ index }) => index.isUCAuthentication);
      if (
        isEmpty(initApp.phone) &&
        product !== 'ESHOP' &&
        !isUCAuthentication &&
        userDimension === 'SUBS_MSISDN'
      ) {
        yield put({
          type: 'save',
          payload: {
            Luckycode: '3',
          },
        });
        return null;
      }
      let resp = {};
      if (payload.luckyDrawType === 'K') {
        // 锦鲤夺宝
        resp = yield call(qryLuckyDrawDetailKOIDXP, payload.gameCode) || {};
      } else if (payload.luckyDrawType === 'S') {
        // 签到
        resp = yield call(qryLuckyDrawDetailSignDXP, payload.gameCode) || {};
      } else if (payload.luckyDrawType === 'C' || payload.luckyDrawType === 'J') {
        // 分享
        resp = yield call(qryLuckyDrawDetailReferralDXP, payload.gameCode) || {};
      } else {
        // 大转盘九宫格
        resp = yield call(qryLuckyDrawDetailWheelDXP, payload.gameCode) || {};
      }

      try {
        const dataTemp = get(resp, 'data') || {};
        resp = {
          ...resp,
          retCode: resp.resultCode,
          retDesc: resp.resultMsg,
          data: {
            ...dataTemp,
            promotionName: dataTemp.gameName,
            promotionId: dataTemp.gameCode,
            drawMoreOneTime: dataTemp.allowMultiBet ? 'Y' : 'N',
            promotionCode: dataTemp.gameCode,
            luckyDrawType: dataTemp.gameType || payload.luckyDrawType,
            lotteryStatus: dataTemp.gameState,
            state: dataTemp.gameState,
            playChances: dataTemp.playChancesNum,
            numberOfParticipants: dataTemp.gameParticipantsNum,
            numberOfUserParticipants: dataTemp.userParticipantsNum,
            pointExchangeChanceFlag: dataTemp.canPointsToRedeemChance ? 'Y' : 'N',
            taskCenterPromoId: dataTemp.challengeId,
            reducePointNum: dataTemp.pointNumForExchangeChance,
            exchangeMethod: dataTemp.pointsExchangeChanceMethod,
            exceedLimitTimes: dataTemp.isExceedLimitTimes,
            participentShowFlag: dataTemp.canShowParticipentTimes,
            shortLink: dataTemp.c2cShortLink,
            subNumType: dataTemp.subscriberScopeForRewardClaim,
            chooseSubNumMethod: dataTemp.chooseSubscriberMethod,
            promotionPointExchangeRuleDto: dataTemp.pointsExchangeChanceRule,
            enabled: dataTemp.isRequireAudit ? 'Y' : 'N',
            switchSetting: dataTemp.isDefaultOpen,
            promotionMediaItemDtoList: dataTemp.mediaItemList,
            promotionRewardMemDtoList: dataTemp.rewardList?.map(rewardItem => ({
              ...(rewardItem || {}),
              numberOfPrizes: rewardItem.rewardNum,
            })),
            promotionAttrList: dataTemp.attrList,
            promotionDailyCheckInDto: {
              ...(dataTemp.dailyCheckInRule || {}),
              patchSwitch: dataTemp?.dailyCheckInRule?.canPatch,
            },
            promotionEventLinkList: dataTemp.eventUrlList?.map((item, index) => ({
              ...item,
              eventLinkId: index + 1,
            })),
            column1: dataTemp.nextGameStartDate,
            column2: dataTemp.nextGameDrawDate,
            patchMaximumTime: dataTemp.patchMaximumTimes,
            patchConsumeType: dataTemp.patchPointType,
            patchConsumeNum: dataTemp.patchPointAmount,
            linkContentType: dataTemp.linkTypeOfTC,
            effDate: dataTemp.startDate,
            expDate: payload.luckyDrawType === 'K' ? dataTemp.drawingDate : dataTemp.endDate,
          },
        };
        const data = get(resp, 'data');
        const code = get(resp, 'retCode');
        const luckyDrawType = get(data, 'luckyDrawType');
        const rewardsList = get(data, 'promotionRewardMemDtoList') || [];
        // const retDesc = get(resp, 'retDesc');
        yield put({
          type: 'save',
          payload: {
            Luckycode: code,
          },
        });
        // 0表示成功
        if (code === '0') {
          const pageRenderDetailObj =
            luckyDrawType === 'J'
              ? JSON.parse(
                  data?.promotionMediaItemDtoList?.find(
                    item => item.itemPartType === 'D' && item?.mediaType === 'J',
                  )?.extData || '{}',
                )
              : {};
          const columnObj = luckyDrawType === 'J' ? JSON.parse(data?.column1) : {};
          yield put({
            type: 'save',
            payload: {
              activityDetail: data || {},
              Luckycode: code,
              luckyDrawType,
              luckyDrawState: get(data, 'state'),
              exchangeChanceFlag: get(data, 'pointExchangeChanceFlag'),
              product: get(data, 'product'),
              userDimension: get(data, 'userDimension'),
              isManual: get(columnObj, 'isManual'),
              applyTo: get(columnObj, 'applyTo'),
              pageRenderDetail: pageRenderDetailObj,
              referralServerUrl: data?.promotionMediaItemDtoList?.find(
                item => item.itemPartType === 'D' && item?.mediaType === 'J',
              )?.serverUrl,
              rewardsList,
            },
          });
        } else {
          // Toast.show({ icon: 'fail', content: retDesc });
        }
      } catch (e) {
        Toast.show({ icon: 'fail', content: e.Error });
      }
      return resp;
    },
    *getLuckyDrawRuleDXP({ payload }, { call }) {
      const { data } = yield call(getPromotionLuckyDrawRuleDXP, payload) || {};
      return data?.rulesDetail || '';
    },
    *getAchieveRecordsDXP({ payload }, { put, call }) {
      try {
        const resp = yield call(getAchieveRecordsDXP, payload);
        let data = cloneDeep(get(resp, 'data') || []);
        const code = get(resp, 'resultCode');
        const retDesc = get(resp, 'resultMsg');
        data = data.map(item => ({
          ...item,
          msisdn: item.userName,
        }));
        // 0表示成功
        if (code === '0') {
          yield put({
            type: 'save',
            payload: {
              winningUserList: data || {},
            },
          });
        } else {
          Toast.show({ icon: 'fail', content: retDesc });
        }
      } catch (e) {
        Toast.show({ icon: 'fail', content: e.Error });
      }
    },
    // 查询配置项信息
    *getConfigParamDXP({ payload }, { call }) {
      const resp = yield call(getConfigParamBatch, payload);
      const data = get(resp, 'data') || {};
      const code = get(resp, 'resultCode');
      const retDesc = get(resp, 'resultMsg');
      try {
        if (code === '0') {
          // yield put({
          //   type: 'save',
          //   payload: {
          //     useInfo: data,
          //   },
          // });
          return data?.[0] || {};
        }
        Toast.show({ icon: 'fail', content: retDesc });
        return null;
      } catch (e) {
        Toast.show({ icon: 'fail', content: e.Error });
      }
      return null;
    },
    // 是否uc鉴权
    *isUCAuthentication({ payload }, { put, call }) {
      const resp = yield call(getConfigParam, payload);
      const data = get(resp, 'data') || {};
      const code = get(resp, 'retCode');
      const retDesc = get(resp, 'retDesc');
      try {
        if (code === '0') {
          yield put({
            type: 'save',
            payload: {
              isUCAuthentication: data.paramValue === 'Y',
              // isUCAuthentication: true,
            },
          });
          return data;
        }
        Toast.show({ icon: 'fail', content: retDesc });
        return null;
      } catch (e) {
        Toast.show({ icon: 'fail', content: e.Error });
      }
      return null;
    },
    // 查询是否需要鉴权
    *qryWithoutAuthentification({ payload }, { call, put }) {
      const resp = yield call(getConfigParam, payload);
      const data = get(resp, 'data') || {};
      const code = get(resp, 'retCode');
      const retDesc = get(resp, 'retDesc');
      try {
        if (code === '0') {
          yield put({
            type: 'save',
            payload: {
              withoutAuthentification: data?.paramValue,
            },
          });
          return data.paramValue;
        }
        Toast.show({ icon: 'fail', content: retDesc });
        return null;
      } catch (e) {
        Toast.show({ icon: 'fail', content: e.Error });
      }
      return null;
    },
    *qryPlayChancesDXP({ payload }, { put, call }) {
      try {
        const resp = yield call(qryPlayChancesDXP, payload);
        const data = get(resp, 'data');
        const code = get(resp, 'resultCode');
        const retDesc = get(resp, 'resultMsg');
        // 0表示成功
        if (code === '0') {
          yield put({
            type: 'save',
            payload: {
              defaultPlayChances: data?.playChancesNum || 0,
            },
          });
        } else {
          Toast.show({ icon: 'fail', content: retDesc });
        }
      } catch (e) {
        Toast.show({ icon: 'fail', content: e.Error });
      }
    },
    *toPlayDXP({ payload }, { put, call }) {
      let resp = yield call(toPlayDXP, payload);
      resp = cloneDeep(resp);
      resp = {
        ...resp,
        retCode: resp.resultCode,
        retDesc: resp.resultDesc,
        data: {
          ...(resp?.data || {}),
          playChances: resp?.data?.remainingPlayChances,
          promotionRewardMemDto: resp?.data?.reward,
          exceedLimitTimes: resp?.data?.isExceedLimitTimes,
        },
      };
      const data = get(resp, 'data') || {};
      const code = get(resp, 'resultCode');
      const retDesc = get(resp, 'resultDesc');
      // 0表示成功
      if (code === '0') {
        yield put({
          type: 'save',
          payload: {
            winningReward: data,
          },
        });
        return resp;
      }
      if (code === '-7') {
        return resp;
      }
      Toast.show({ icon: 'fail', content: retDesc });
      return resp;
    },
    // 生成短链接口
    *batchCreateUtmLink({ payload }, { put, call }) {
      try {
        const resp = yield call(batchCreateUtmLink, payload);
        const data = get(resp, 'data.linkList');
        const code = get(resp, 'retCode');
        const retDesc = get(resp, 'retDesc');
        // 0表示成功
        if (code === '0') {
          yield put({
            type: 'save',
            payload: {
              shortLink: get(head(data), 'shortLink'),
            },
          });
          return resp;
        }
        Toast.show({ icon: 'fail', content: retDesc });
        return null;
      } catch (e) {
        Toast.show({ icon: 'fail', content: e.Error });
        return null;
      }
    },
    // 积分兑换抽奖次数DXP
    *reducePointGetChancesDXP({ payload }, { put, call }) {
      try {
        let resp = yield call(reducePointGetChancesDXP, payload);
        resp = {
          ...resp,
          retCode: resp.resultCode,
          retDesc: resp.resultMsg,
          data: {
            playChances: resp?.data?.exchangedChanceNum,
            changeChances: resp?.data?.remainingChanceNum,
            retCode: resp.resultCode,
            retDesc: resp.resultMsg,
          },
        };
        const data = get(resp, 'data');
        const code = get(resp, 'retCode');
        // 0表示成功
        if (code === '0') {
          yield put({
            type: 'save',
            payload: {
              defaultPlayChances: data.playChances,
            },
          });
          // Toast.success('Points deduction successful!');
          return resp;
        }
        if (code === '-2') {
          return resp;
        }
        Toast.show({
          content: get(resp, 'retDesc') || 'Point conversion failed. Please try again.',
        });
        return null;
      } catch (e) {
        Toast.show({ icon: 'fail', content: e.Error });
        // Toast.fail('Timeout');
        return null;
      }
    },
    // 积分兑换抽奖次数重试DXP
    *reducePointGetChancesRetryDXP({ payload }, { put, call }) {
      try {
        let resp = yield call(reducePointGetChancesRetryDXP, payload);
        resp = {
          ...resp,
          retCode: resp.resultCode,
          retDesc: resp.resultMsg,
          data: {
            playChances: resp?.data?.exchangedChanceNum,
            changeChances: resp?.data?.remainingChanceNum,
            retCode: resp.resultCode,
            retDesc: resp.resultMsg,
          },
        };
        const data = get(resp, 'data');
        const code = get(resp, 'retCode');
        // 0表示成功
        if (code === '0') {
          yield put({
            type: 'save',
            payload: {
              defaultPlayChances: data.playChances,
            },
          });
          // Toast.success('Points deduction successful!');
          return resp;
        }
        if (code === '-2') {
          return resp;
        }
        Toast.show({
          content: get(resp, 'retDesc') || 'Point conversion failed. Please try again.',
        });
        return null;
      } catch (e) {
        Toast.show({ icon: 'fail', content: e.Error });
        // Toast.fail('Timeout');
        return null;
      }
    },
    // 批量查询配置项
    *getConfigParamBatch({ payload }, { call, put }) {
      const resp = yield call(getConfigParamBatch, payload);
      const configList = get(resp, 'data') || [];
      const projectObj =
        configList.find(item => item.paramCode === 'PROMOTION_PROGECT_IDENTIFICATION') || {};
      const timeFormateObj =
        configList.find(item => item.paramCode === 'TIME_DISPLAY_FORMAT') || {};
      const sensorsInitObj =
        configList.find(item => item.paramCode === 'EVENT_REPORT_SERVER_URL') || {};
      const gaResult = configList.find(item => item.paramCode === 'GA_REPORT_SERVER_CONFIG') || {};
      const withoutAuthentificationObj =
        configList.find(item => item.paramCode === 'webs.ecare.signcode.develop.model') || {};
      const isUCAuthenticationObj =
        configList.find(item => item.paramCode === 'use.UC.authentication.switch') || {};
      const isMulPointsObj =
        configList.find(item => item.paramCode === 'DC_LOYALTY_POINT-MULTIPLE-ACCOUNT') || {};

      const code = get(resp, 'resultCode');
      const retDesc = get(resp, 'resultMsg');

      try {
        if (code === '0') {
          const timeFormate = get(timeFormateObj, 'paramValue') || 'YYYY-MM-DD HH:mm:ss';
          localStorage.setItem('timeFormate', timeFormate);
          yield put({
            type: 'save',
            payload: {
              isPto: projectObj.paramValue === 'PTO',
              projectName: projectObj.paramValue,
              projectNamedd: projectObj.paramValue,
              isUCAuthentication: isUCAuthenticationObj.paramValue === 'Y',
              withoutAuthentification: withoutAuthentificationObj.paramValue,
              sensorsUrl: sensorsInitObj.paramValue,
              gaResult: gaResult.paramValue,
              isMulPoints: isMulPointsObj.paramValue === '1',
            },
          });
          return configList;
        }
        Toast.show({ icon: 'fail', content: retDesc });
        return [];
      } catch (e) {
        Toast.show({ icon: 'fail', content: e.Error });
      }
      return [];
    },
    // 获取谷歌埋点上报配置
    *getGAReportConfig(_, { call }) {
      try {
        const resp = yield call(getGAReportConfig);
        const code = get(resp, 'resultCode');
        if (code === '0') {
          return get(resp, 'data.configValue');
        }
      } catch {
        // ignore
      }
      return null;
    },
    // 查询是否是PTO项目，产品做项目的定制化
    // *qryProject({ payload }, { call, put }) {
    //   const resp = yield call(qryConfigItemParamValueByCode, { paramCode: payload });
    //   const paramValue = get(resp, 'data.paramValue');
    //   yield put({
    //     type: 'save',
    //     payload: {
    //       isPto: paramValue === 'PTO',
    //       projectName: paramValue,
    //     },
    //   });
    //   return paramValue;
    // },

    // 查询用户信息
    *qryUserInfo({ payload }, { call }) {
      try {
        const resp = yield call(qryUserInfo, payload);
        const data = get(resp, 'data');
        const code = get(resp, 'retCode');
        const retDesc = get(resp, 'retDesc');
        // 0表示成功
        if (code === '0') {
          return data;
        }
        Toast.show({ icon: 'fail', content: retDesc });
        return {};
      } catch (e) {
        Toast.show({ icon: 'fail', content: e.Error });
        return {};
      }
    },
    // 查询用户信息
    *qryUserInfoDXP({ payload }, { call }) {
      try {
        const resp = yield call(qryUserInfoDXP, payload);
        const data = get(resp, 'data');
        const code = get(resp, 'resultCode');
        const retDesc = get(resp, 'resultMsg');
        // 0表示成功
        if (code === '0') {
          return data;
        }
        Toast.show({ icon: 'fail', content: retDesc });
        return {};
      } catch (e) {
        Toast.show({ icon: 'fail', content: e.Error });
        return {};
      }
    },
    // eshop通过token获取用户信息
    *qryEshopUser({ payload }, { call }) {
      try {
        const resp = yield call(qryEshopUser, payload);
        const data = get(resp, 'data');
        const code = get(resp, 'retCode');
        const retDesc = get(resp, 'retDesc');
        // 0表示成功
        if (code === '0') {
          return data;
        }
        Toast.show({ icon: 'fail', content: retDesc });
        return null;
      } catch (e) {
        Toast.show({ icon: 'fail', content: e.Error });
        return null;
      }
    },
    // 获取国内长途前缀接口
    *qryNationalPrefix({ payload }, { call }) {
      try {
        const resp = yield call(qryNationalPrefix, payload);
        const data = get(resp, 'data');
        const code = get(resp, 'resultCode');
        const retDesc = get(resp, 'resultMsg');
        // 0表示成功
        if (code === '0') {
          return data;
        }
        Toast.show({ icon: 'fail', content: retDesc });
        return {};
      } catch (e) {
        Toast.show({ icon: 'fail', content: e.Error });
        return {};
      }
    },
    *qryBalanceOfPointsDXP({ payload }, { call }) {
      try {
        const resp = yield call(qryBalanceOfPointsDXP, payload);
        let data = get(resp, 'data');
        data = {
          ...data,
          points: data.availablePoint,
          pointsInt: data.availablePointInt,
          status: data.state,
        };
        const code = get(resp, 'resultCode');
        const retDesc = get(resp, 'resultDesc');
        // 0表示成功
        if (code === '0') {
          return data;
        }
        Toast.show({ icon: 'fail', content: retDesc });
        return {};
      } catch (e) {
        Toast.show({ icon: 'fail', content: e.Error });
        return {};
      }
    },
    *qryAppCode(_, { call }) {
      const resp = yield call(qryAppCode);
      return resp.data;
    },
    // 积分转账
    *pointTransferDXP({ payload }, { call }) {
      try {
        const resp = yield call(pointTransferDXP, payload);
        const data = get(resp, 'data') || {};
        const code = get(resp, 'resultCode');
        // const retDesc = get(resp, 'retDesc');
        // 0表示成功
        if (code === '0') {
          return data;
        }
        // Toast.show({ icon: 'fail', content: retDesc });
        return {};
      } catch (e) {
        Toast.show({ icon: 'fail', content: e.Error });
        return {};
      }
    },
    // 积分转账单笔最大限制
    *pointTransferLimits({ payload }, { call }) {
      try {
        const resp = yield call(pointTransferLimits, payload);
        const data = get(resp, 'data') || {};
        const code = get(resp, 'resultCode');
        // const retDesc = get(resp, 'retDesc');
        // 0表示成功
        if (code === '0') {
          return data;
        }
        // Toast.show({ icon: 'fail', content: retDesc });
        return [];
      } catch (e) {
        Toast.show({ icon: 'fail', content: e.Error });
        return [];
      }
    },
    // 查询用户劵实例
    *qryVoucherListDXP({ payload }, { call }) {
      try {
        const resp = yield call(qryVoucherListDXP, payload);
        const data = get(resp, 'data');
        const code = get(resp, 'resultCode');
        const retDesc = get(resp, 'retDesc');
        // 0表示成功
        if (code === '0') {
          return data || [];
        }
        Toast.show({ icon: 'fail', content: retDesc });
        return [];
      } catch (e) {
        Toast.show({ icon: 'fail', content: e.Error });
        return [];
      }
    },
    // 查询用户劵实例
    *qryThemesLatest({ payload }, { call }) {
      try {
        const resp = yield call(qryThemesLatest, payload);
        const data = get(resp, 'data');
        const code = get(resp, 'resultCode');
        const retDesc = get(resp, 'retDesc');
        // 0表示成功
        if (code === '0') {
          return data || {};
        }
        Toast.show({ icon: 'fail', content: retDesc });
        return {};
      } catch (e) {
        Toast.show({ icon: 'fail', content: e.Error });
        return {};
      }
    },
    *qryApiSgAuthToken({ payload }, { call }) {
      const result = yield call(qryApiSgAuthToken, payload);
      return result;
    },
    *getUtmLink({ payload }, { call }) {
      const result = yield call(getUtmLink, payload?.id);
      return result;
    },
    // 查询Eshop登录页面Url
    *qryEshopLoginUrl({ payload }, { call }) {
      const resp = yield call(qryConfigItemParamValueByCode, { paramCode: payload });
      const data = get(resp, 'data.paramValue');
      return data;
    },
    *getLocalI18n({ payload }, { call }) {
      try {
        const { appCode } = payload;
        const resp = yield call(getLocalI18n, appCode) || {};
        return resp || {};
      } catch (e) {
        return {};
      }
    },
    *getGameI18n({ payload }, { call }) {
      const { promotionId } = payload;
      try {
        const resp = yield call(getGameI18n, promotionId) || {};
        return resp || {};
      } catch (e) {
        return {};
      }
    },
    *qryDefaultConfig(_, { call }) {
      const result = yield call(qryDefaultConfig);
      if (result && typeof result === 'object') {
        if (!isEmpty(result)) {
          window.sessionStorage.setItem('x-default-config', JSON.stringify(result));
        }
      }
    },
  },
};
